"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphqlServerModule = void 0;

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _apolloClient = require("apollo-client");

var _apolloLink = require("apollo-link");

var _apolloLinkHttp = require("apollo-link-http");

var _default = require("./config/default.config");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var is = require("is_js");

var GraphqlServerModule = /*#__PURE__*/function () {
  function GraphqlServerModule() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, GraphqlServerModule);

    _defineProperty(this, "name", _default.DEFAULT_CONFIG === null || _default.DEFAULT_CONFIG === void 0 ? void 0 : _default.DEFAULT_CONFIG.name);

    _defineProperty(this, "registry", []);
  }

  _createClass(GraphqlServerModule, [{
    key: "createClient",
    value: function () {
      var _createClient = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name, _ref) {
        var url, getContext, httpLink, authMiddleware, link, client;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _ref.url, getContext = _ref.getContext;

                if (!(is.not.existy(url) || is.empty(url) || is.not.url(url))) {
                  _context.next = 3;
                  break;
                }

                throw Error("url cannot be null or empty");

              case 3:
                if (!_lodash.default.find(this.registry, {
                  name: name
                })) {
                  _context.next = 5;
                  break;
                }

                throw Error("This client connection ".concat(name, " already exists"));

              case 5:
                httpLink = new _apolloLinkHttp.HttpLink({
                  uri: url
                });
                authMiddleware = new _apolloLink.ApolloLink(function (operation, forward) {
                  // add the authorization to the headers
                  var context = getContext();
                  operation.setContext(context);
                  return forward(operation);
                });
                link = (0, _apolloLink.from)([authMiddleware, httpLink]);
                client = new _apolloClient.ApolloClient({
                  link: link,
                  cache: new _apolloCacheInmemory.InMemoryCache({
                    addTypename: false
                  })
                });
                this.registry.push({
                  name: name,
                  client: client
                });
                return _context.abrupt("return", client);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createClient(_x, _x2) {
        return _createClient.apply(this, arguments);
      }

      return createClient;
    }()
  }, {
    key: "getClient",
    value: function getClient(name) {
      var found = _lodash.default.find(this.registry, {
        name: name
      });

      if (!found) {
        throw Error("client connection ".concat(name, " not found"));
      }

      return found.client;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.instance) {
        this.instance = new GraphqlServerModule(props);
      }

      return this.instance;
    }
  }]);

  return GraphqlServerModule;
}();

exports.GraphqlServerModule = GraphqlServerModule;

_defineProperty(GraphqlServerModule, "instance", void 0);